import { Component, DestroyRef, OnInit } from '@angular/core';

import { HttpService } from 'app/services/http.service';
import { Permission, PermissionType } from 'app/models/control-center/permission.model';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { ScannerService } from './services/scanner.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loading = true;
  title = 'weavix-control-center-frontend';
  authenticated = false;

  authenticatedPerson = '';
  authenticatedCompany = '';

  permissions: Permission;
  permissionType = PermissionType;

  characters: string[] = [];
  lastKeypress: number = Date.now();

  constructor(
    private readonly _httpService: HttpService,
    private readonly _router: Router,
    private readonly _authService: AuthService,
    private readonly _scannerService: ScannerService,
    private readonly _destroyRef: DestroyRef,
  ) { }

  async ngOnInit() {
    this.loading = true;
    try {
      const response = await this._httpService.get('authentication/authenticate');
      if (response.status === 'ok') {
        this.authenticated = true;
        this.authenticatedPerson = response.name;
        this.authenticatedCompany = response.company;
        this.permissions = await this._httpService.get('people/authenticated/permissions');
        this._scannerService.onScan$.pipe(
            takeUntilDestroyed(this._destroyRef),
        ).subscribe(async serialNumber => {
            if (location.href.includes('scanner')) return;
            try {
                const result = await this._httpService.get(`inventory/assets?serialNumber=${serialNumber}`);
                if (result) {
                    this._router.navigateByUrl(`/inventory/assets/${result.id}`);
                }
            } catch (ex) {
                console.error('Error fetching asset:', ex);
            }
        });
      } else this.authenticated = false;
      this.loading = false;
      return;
    } catch {
      this.authenticated = false;
      this.loading = false;
      return;
    }
  }

  authenticate() {
    this.authenticated = true;
  }

  async logOut() {
    this._authService.logOut();
  }
}
